export default function (state, data) {
    state.loading = false;
    state.items = [];
    state.page = 1;
    setRow(data, state.items);
    function setRow(data, list) {
        data.forEach(i=>{
            // i.Acc = i.Acc||i.Acc1||i.Acc2;
            list.push(i);
            if(i.ChildRows&&i.ChildRows.length){
                setRow(i.ChildRows, list)
            }
        })
    }
}